import { DatePicker, Input, Modal, Radio, Spin, Tooltip } from 'antd'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { FormWrapperInputComponent, ListComponent } from '../../../../common/component/Index'
import Wrapper from '../../../../common/component/Wrapper'
import * as Func from '../../../../../../helpers/functions';
import AntSelect, { AntOption } from '../../../../common/component/AntSelect'
import moment from 'moment'
import { DATE_TIME_FORMAT, ORDER } from '../../../../../../constants/Define'
import CustomerFormItem from './CustomerFormItem/CustomerFormItem'
import { findIndex } from 'lodash';

let displayMonth = null

const ListCols = ['id', 'ticketName', 'objectType', 'quantity'];
const ModelObjectFields = ['id', 'ticketName', 'objectType', 'quantity'];

class ModalSKU extends Component {
    constructor() {
        super()
        this.state = {
            ticketTable: {
                titleTable: Func.getTitleTable(ListCols, [], ['id']),
                modelTicket: ModelObjectFields,
                componentTable: {
                    objectType: {
                        render: (value, record) => value.name,
                    },
                    quantity: {
                        render: (value, record) => (
                            <Input
                                placeholder={ this.props.t(`item.tourTicket.quantity`) }
                                className={ `form-control` } 
                                name={ `quantity` } onChange={ (e) => this.props.onChangeQuantityTicket(record.id, Number(e.target.value)) }
                                value={ value } autoComplete="off"/>
                        )
                    }
                },
            },
            typeSKU: 1, // Voucher ( 1 ) | Tour ( 2 ) | Vinwonder (7)
            skuFilterByType: []
        }
    }

    componentDidMount(){
        this.getSkuFilterByType();
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.props.tourState.detail.tour.type && prevProps.tourState.detail.tour.type !== this.props.tourState.detail.tour.type && this.props.tourState.detail.tour.type === 1) {
            this.props.getTourLineTickets(undefined, this.props.tourState.detail.tour.id, true);
        }

        // load vinwonder when has customer list
        if(this.props.customerState && this.props.customerState.length && prevProps.customerState !== this.props.customerState) {
            this.props.getVinWonderTypes();
        }

        // load section/zone when has vinwonder type list
        if(this.props.vinWonderState.vinWonderTypes 
            && this.props.vinWonderState.vinWonderTypes.length 
            && prevProps.vinWonderState.vinWonderTypes !== this.props.vinWonderState.vinWonderTypes
            && this.props.ticketState?.length) {
            const sessionKey = this.props.vinWonderState.vinWonderTypes.find(x=>x.id === ORDER.VINWONDER_ITEM_TYPE.SUBMARINE)?.code;
            const payload = {
                siteCode: this.props.ticketState[0].siteCode,
                sessionKey: sessionKey,
                date: this.props.dataSKU?.bookingDate?.format(DATE_TIME_FORMAT.SHORT_DATE_EXPORT)}
            this.props.getVinwonderSessions(payload);
            this.props.getVinwonderZones();
        }

        if (this.state.typeSKU && prevState.typeSKU !== this.state.typeSKU) {
            this.getSkuFilterByType();
        }
    }

    getSkuFilterByType() {
        const skuFilterByType = (this.props.tourState?.allTours?.tours || []).filter(item => item.type === this.state.typeSKU);
        this.setState({ skuFilterByType });
    }

    render() {
        const { t, visible, dataSKU, validation, validationCustomer, validationSessionZone, tourState, ticketState, customerState, lengthOfTour, isValidSubmarineQuantity, saleOrderItems, vinWonderState, saleOrder } = this.props
        const { ticketTable, typeSKU, skuFilterByType } = this.state
        const { titleTable, modelTicket, componentTable } = ticketTable;
        const { vinWonderSessions, vinWonderZones } = vinWonderState;

        const returnDate = dataSKU.bookingDate && moment(dataSKU.bookingDate, DATE_TIME_FORMAT.SHORT_DATE)
        .add(Math.floor(lengthOfTour) - (typeSKU === 7 ? 0 : 1), 'days')
        .format(DATE_TIME_FORMAT.SHORT_DATE)

        const isVinwonderSubmarine = (saleOrderItems || []).findIndex(x=>x.vwType === 4) > -1;

        return (
            <Modal
                className="sale-order"
                width={900}
                destroyOnClose={true}
                maskClosable={false}
                visible={visible}
                title={t(`item.order.titleModalSKU`)}
                onOk={this.handleOk}
                okText={t(`item.order.addTicket`)}
                onCancel={this.handleCancel} 
                cancelText={t(`action.cancel`)}
            >
                <Spin spinning={tourState.isFetchingUpdate || tourState.isTourLineFetching}>
                    <Wrapper className="row">
                        <Wrapper className="col-md-12 m-b">
                            <Radio.Group defaultValue={1} buttonStyle="solid" onChange={this.onChangeType}>
                                <Radio.Button value={1}>Voucher</Radio.Button>
                                <Radio.Button value={2}>Tour</Radio.Button>
                                <Radio.Button value={7}>Vinwonder</Radio.Button>
                            </Radio.Group>
                        </Wrapper>
                        <Wrapper className="col-md-8">
                            <FormWrapperInputComponent
                                isRequired={'right'}
                                isValidation={true}
                                dataValidation={dataSKU.skuId}
                                validation={validation.skuId}
                                labelTitle={t(`item.group.title`)}
                            >
                                <AntSelect className="select-group"
                                    showArrow showSearch
                                    placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.group.title")).toLowerCase())}
                                    value={dataSKU.skuId}
                                    onChange={(value) => {
                                        this.onChangeTour(value)
                                    }}
                                    style={{ width: '100%' }}
                                    filterOption={this.selectFilterSearch}
                                    disabled={isVinwonderSubmarine}
                                >
                                    {skuFilterByType.map(g => (
                                        <AntOption key={g.id} value={g.id}>
                                            <Tooltip title={g.tourName} placement="topLeft">{`${g.tourCode} - ${g.tourName}`}</Tooltip>
                                        </AntOption>
                                    ))}
                                </AntSelect>
                            </FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-4">
                            { (tourState.detail.tour.type === 2 || tourState.detail.tour.type === 7) && 
                                <FormWrapperInputComponent
                                    isRequired={'right'}
                                    isValidation={true}
                                    dataValidation={dataSKU.bookingDate}
                                    validation={validation.bookingDate}
                                    labelTitle={t(`item.tour.bookingDate`)}
                                >
                                    <DatePicker
                                        dateRender={this.dateRender}
                                        allowClear={false}
                                        value={dataSKU.bookingDate && new moment(dataSKU.bookingDate, DATE_TIME_FORMAT.SHORT_DATE)}
                                        disabledDate={this.disabledBookingDate}
                                        onChange={this.onChangeDate}
                                        onOpenChange={this.onOpenChange}
                                        minDate={new Date()}
                                        format={`DD/MM/YYYY${returnDate ? ` - ${returnDate}` : ''}`}
                                        formatDateInput={DATE_TIME_FORMAT.SHORT_DATE}
                                        formatDateOutput={DATE_TIME_FORMAT.SHORT_DATE}
                                        placeholder={t('item.tour.bookingDate')}
                                        className="w100-percent"
                                        onChangeDisplayMonth={this.onChangeDisplayMonth}
                                        customDropdownClass='vpt-date-picker__tour-detail'
                                        disabled={!dataSKU.skuId}
                                    />
                                </FormWrapperInputComponent>
                            }
                        </Wrapper>
                        
                        <Wrapper className="col-md-12">
                            <ListComponent
                                tableKey="table-tour-ticket-object-type"
                                rowKey={ record => record.id }
                                dataSource={ Func.getDataSource(ticketState, modelTicket) }
                                columns={ Func.columnsTable({
                                    titleTable: titleTable,
                                    component: componentTable,
                                    itemName: 'tourTicket'
                                }) }
                            />
                            {
                                !isValidSubmarineQuantity &&
                                <label class="fs15"><span style={{color: "red", fontSize: "13px"}}>{t("item.order.submarineMaxQuantity") + ORDER.MAX_SUBMARINE}</span></label>
                            }
                        </Wrapper>

                        {
                            (customerState && customerState.length) &&
                            (
                                <Wrapper className="col-md-12">
                                    <Wrapper className="row mt-3">
                                        <Wrapper className="col-md-4">
                                            <FormWrapperInputComponent 
                                                className="form-group mr-2"
                                                labelHeaderStart={true}
                                                isRequired={'right'}
                                                isValidation={true}
                                                dataValidation={validation.sessionId}
                                                validation={validationSessionZone.sessionId}
                                                labelTitle={t(`item.order.session`)}
                                            >
                                                <AntSelect
                                                className="select-group"
                                                showArrow
                                                allowClear
                                                value={saleOrder.sessionId}
                                                onChange={(e) => this.props.onChange("sessionId", e)}
                                                style={{ width: '100%' }}
                                                >
                                                {vinWonderSessions.map((g) => (
                                                    <AntOption key={g.sessionID} value={g.sessionID}>
                                                    <Tooltip title={this.formatSession(g.startHour, g.startMinute)} placement="left">
                                                        {this.formatSession(g.startHour, g.startMinute)}
                                                    </Tooltip>
                                                    </AntOption>
                                                ))}
                                                </AntSelect>
                                            </FormWrapperInputComponent>
                                        </Wrapper>

                                        <Wrapper className="col-md-4">
                                            <FormWrapperInputComponent 
                                                className="form-group mr-2"
                                                isRequired={'right'}
                                                isValidation={true}
                                                dataValidation={saleOrder.zonePickupId}
                                                validation={validationSessionZone.zonePickupId}
                                                labelTitle={t(`item.order.zonePickup`)}
                                            >
                                                <AntSelect
                                                className="select-group"
                                                showArrow
                                                allowClear
                                                value={saleOrder.zonePickupId}
                                                onChange={(e) => this.props.onChange("zonePickupId", e)}
                                                style={{ width: '100%' }}
                                                >
                                                {vinWonderZones.map((g) => (
                                                    <AntOption key={g.id} value={g.id}>
                                                    <Tooltip title={g.label} placement="left">
                                                        {g.label}
                                                    </Tooltip>
                                                    </AntOption>
                                                ))}
                                                </AntSelect>
                                            </FormWrapperInputComponent>
                                        </Wrapper>

                                        <Wrapper className="col-md-4">
                                            <FormWrapperInputComponent 
                                                className="form-group"
                                                isRequired={'right'}
                                                isValidation={true}
                                                dataValidation={saleOrder.zoneReleaseId}
                                                validation={validationSessionZone.zoneReleaseId}
                                                labelTitle={t(`item.order.zoneRelease`)}
                                            >
                                                <AntSelect
                                                className="select-group"
                                                showArrow
                                                allowClear
                                                value={saleOrder.zoneReleaseId}
                                                onChange={(e) => this.props.onChange("zoneReleaseId", e)}
                                                style={{ width: '100%' }}
                                                >
                                                {vinWonderZones.map((g) => (
                                                    <AntOption key={g.id} value={g.id}>
                                                    <Tooltip title={g.label} placement="left">
                                                        {g.label}
                                                    </Tooltip>
                                                    </AntOption>
                                                ))}
                                                </AntSelect>
                                            </FormWrapperInputComponent>
                                        </Wrapper>
                                    </Wrapper>
                                    {
                                        customerState.map((item, index) => (
                                            <CustomerFormItem key={index} index={index} item={item} onChange={this.props.onChangeCustomer} validation={validationCustomer}></CustomerFormItem>
                                        ))
                                    }
                                </Wrapper>
                            )
                        }
                        
                    </Wrapper>
                </Spin>
            </Modal>
        )
    }

    handleCancel = () => {
        this.setState({ typeSKU: 1 })
        return this.props.onCancel()
    }

    handleOk = () => {
        this.setState({ typeSKU: 1 })
        return this.props.addTicket()
    }

    onChangeType = (e) => {
        this.setState({
            typeSKU: e.target.value
        })
        this.props.onChangeTypeSKU(e.target.value)
    }

    onChangeTour = (value) => {
        displayMonth = null
        this.props.selectSku(value)
        this.props.getTourDetail(value);
    }

    getTourLineItemByDate = (date) => {
        const { tourState } = this.props;
        const { detail } = tourState;
        return date && detail.tourLines && detail.tourLines && detail.tourLines.find(
          item => moment(item.departureDate).isSame(date, 'day')
        )
    }
    
    disabledBookingDate = (current) => {
        const { tourState } = this.props;
        const { lengthOfTour } = this.state
        let disabled = false;
        if (!disabled && tourState.detail.tour.stayStartDate && tourState.detail.tour.stayEndDate) {
          const lengthOfTourDays = lengthOfTour ? Math.floor(lengthOfTour) : 0;
          const startDate = moment();
          const start = startDate.add(tourState.detail.tour.cutOffDate ? Math.max(tourState.detail.tour.cutOffDate - 1, 0) : 0, 'days')
          const end = moment(tourState.detail.tour.stayEndDate).subtract(Math.max(lengthOfTourDays - 1, 0), 'days')
          disabled = !current.isBetween(start, end, 'dates', '[]')
        }
        if (!disabled) {
          const tourLineItem = this.getTourLineItemByDate(current);
          disabled = !tourLineItem || tourLineItem.seats <= 0;
        }
        return disabled;
    }

    dateInPickerRender = (current, today) => {
        const { t } = this.props;
        const disabled = this.disabledBookingDate(current);
        const tourLineItem = this.getTourLineItemByDate(current);
        return (
            <div
              className={`ant-calendar-date ${!disabled ? 'g-cursor-pointer g-date-enable' : 'g-cursor-not-allowed ant-picker-cell-inner-disabled'} ${(tourLineItem && tourLineItem.seats <= 0) ? 'out-of-seat' : ''}`}
              style={{ pointerEvents: "all", zIndex: 50 }}
            >
              <span className="number-date">{current.date()}</span>
            </div>
        );
    }

    dateRender = (current, today) => {
        if (current.date() === 15 && this.onChangeDisplayMonth) {
          const month = current.format('MM-YYYY');
          if (month !== displayMonth) {
            this.onChangeDisplayMonth(current)
          }
          displayMonth = month
        }
        if(this.dateInPickerRender) {
            return this.dateInPickerRender(current, today)
        }

        return (
            <div className="ant-calendar-date">
              {current.date()}
            </div>
        );
    }

    onChangeDate = (value) => {
        const { getTourLineTickets, tourState, onChangeDataSKU, onChange } = this.props
        if(tourState.detail.tour.id) {
            const isSaleOrder = true;
            getTourLineTickets((value).format(DATE_TIME_FORMAT.SHORT_DATE_EXPORT), tourState.detail.tour.id, isSaleOrder);

            const curr = tourState.detail.tourLines.find(item => moment(item.departureDate).format(DATE_TIME_FORMAT.SHORT_DATE_EXPORT) === moment(value).format(DATE_TIME_FORMAT.SHORT_DATE_EXPORT));
            onChangeDataSKU('bookingDate', value)
            onChangeDataSKU('seats', curr.seats)
        }
    }

    onOpenChange = (open) => {
        const { onChangeDataSKU, clearTicket } = this.props
        if(open) {
            onChangeDataSKU('bookingDate', null)
            onChangeDataSKU('seats', 0)
            clearTicket()
        }
    }

    onChangeDisplayMonth = (current) => {
        const { tourState } = this.props
        const params = {
            isSaleOrder: true,
            fromDate: moment(current).startOf('month').format('MM-DD-YYYY'),
            toDate: moment(current).endOf('month').format('MM-DD-YYYY'),
        }
        this.props.getListTourLines(tourState.detail.tour.id, params)
    }

    selectFilterSearch = (input, option) => {
        const resultText = option.props.children.props.children;
        return this.getResultSearch(resultText, input)
    }

    getResultSearch = (result, input) => {
        const optionText = Func.vietnameseStringToUnicode(result.toLowerCase());
        const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    }

    formatSession = (hour, minute) => {
        let h = hour < 10 ? "0" + hour : hour;
        let m = minute < 10 ? "0" + minute : minute;
        return h + ":" + m;
      };
}

export default withTranslation()(ModalSKU)